import React from 'react';
import ApplicationFormModular from './ApplicationForm/index';

const ApplicationForm: React.FC = () => {
  return <ApplicationFormModular />;
};

export default ApplicationForm;
